import axios from 'axios';

const ERROR_CONNECTION_ABORTED = 'ECONNABORTED';

// For stubbing in tests
export function request(config) {
  return axios(config);
}

/**
 *
 * @param {Error} error -
 * @returns {boolean}
 */
export function isNetworkTimeoutError(error) {
  return error.code === ERROR_CONNECTION_ABORTED;
}
